<template>
    <div>
         <!-- Why we are section Start -->
  <section class="row_am why_we_section" data-aos="fade-in">
    <div class="why_inner">
      <div class="container">
        <div
          class="section_title"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-delay="100"
        >
          <h2><span>Why we are different</span> from others!</h2>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typese tting
            <br />
            indus orem Ipsum has beenthe standard dummy.
          </p>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-3">
            <div
              class="why_box"
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-delay="100"
            >
              <div class="icon">
                <img src="images/secure_data03.png" alt="image" />
              </div>
              <div class="text">
                <h3>Secure code</h3>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and type
                  setting indus ideas.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div
              class="why_box"
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-delay="200"
            >
              <div class="icon">
                <img src="images/functional02.png" alt="image" />
              </div>
              <div class="text">
                <h3>Fully functional</h3>
                <p>
                  Simply dummy text of the printing and typesetting indus lorem
                  Ipsum is dummy.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div
              class="why_box"
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-delay="300"
            >
              <div class="icon">
                <img src="images/live-chat02.png" alt="image" />
              </div>
              <div class="text">
                <h3>Best communication</h3>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and type
                  setting indus ideas.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div
              class="why_box"
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-delay="400"
            >
              <div class="icon">
                <img src="images/support03.png" alt="image" />
              </div>
              <div class="text">
                <h3>24-7 Support</h3>
                <p>
                  Simply dummy text of the printing and typesetting indus lorem
                  Ipsum is dummy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
    </div>
</template>
<script setup>

</script>
<style scoped>

</style>